import { render, staticRenderFns } from "./SingleAddress.vue?vue&type=template&id=7f87a0a1&"
import script from "./SingleAddress.vue?vue&type=script&lang=js&"
export * from "./SingleAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports